<template lang="html">
    <router-link
        v-if="!$route.meta.isAdmin"
        :to="{ name: 'Account' }"
        id="hamburger"
        :class="{ active: !showNavbar }"
    >
        <span></span>
        <span></span>
        <span></span>
    </router-link>
</template>

<script>
export default {
    name: "account-settings",
    data() {
        return {
            showNavbar: true,
            lastScrollPosition: 0,
        };
    },
    mounted() {
        //window.addEventListener('scroll', this.onScroll)
    },
    beforeDestroy() {
        //window.removeEventListener('scroll', this.onScroll)
    },
    methods: {
        /*
    onScroll () {

      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop

      this.showNavbar = currentScrollPosition < 100
      this.lastScrollPosition = currentScrollPosition
    }
    */
    },
};
</script>

<style lang="scss">
#hamburger {
    width: 60px;
    height: 50px;
    position: absolute;
    top: 16px;
    z-index: 20;
    padding: 0px;
    border: 0px;
    transition: all 0.3s ease-in;
    border-top-right-radius: 12px;
    &.active {
        background: $darkGrey_0;
        border-bottom-right-radius: 12px;
    }
    span {
        width: 5px;
        height: 5px;
        background: white;
        display: inline-block;
        margin-top: 12px;
        margin-left: 4px;
        border-radius: 100%;
        &:first-of-type {
            margin-left: 15px;
        }
    }
    &:first-of-type {
        padding-top: 10px;
    }
}
</style>
